import { useState } from 'react';

interface HeaderProps {
  isScrolled: boolean;
}

export default function Header({ isScrolled }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-lg'
          : 'bg-white/10 backdrop-blur-xs border-b border-white/20'
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <h1>
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('home');
              }}
              className={`text-2xl font-['Pacifico'] cursor-pointer transition-colors ${
                isScrolled ? 'text-teal-600' : 'text-white'
              }`}
            >
              FourShop
            </a>
          </h1>

          <nav className="hidden md:flex space-x-8">
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('home');
              }}
              className={`transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-teal-600'
                  : 'text-white hover:text-teal-100'
              }`}
            >
              Home
            </a>
            <a
              href="#catalogus"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('catalogus');
              }}
              className={`transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-teal-600'
                  : 'text-white hover:text-teal-100'
              }`}
            >
              Catalogus
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact');
              }}
              className={`transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-teal-600'
                  : 'text-white hover:text-teal-100'
              }`}
            >
              Contact
            </a>
          </nav>

          <button
            className={`md:hidden w-6 h-6 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
            aria-label="Toggle menu"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col space-y-3">
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('home');
              }}
              className={`transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-teal-600'
                  : 'text-white hover:text-teal-100'
              }`}
            >
              Home
            </a>
            <a
              href="#catalogus"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('catalogus');
              }}
              className={`transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-teal-600'
                  : 'text-white hover:text-teal-100'
              }`}
            >
              Catalogus
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact');
              }}
              className={`transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-teal-600'
                  : 'text-white hover:text-teal-100'
              }`}
            >
              Contact
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}
